"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const react_1 = __importDefault(require("react"));
const input_styles_1 = require("../input.styles");
const Checkbox = (props) => {
    const { dimension = 'small', checked, onChange = () => { } } = props, restProps = __rest(props, ["dimension", "checked", "onChange"]);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    return (react_1.default.createElement(input_styles_1.CheckBoxElement, Object.assign({ type: "checkbox", checked: checked, onClick: onChange, theme: theme, colors: colors, dimension: dimension }, restProps)));
};
exports.default = Checkbox;
//# sourceMappingURL=checkbox.js.map